import React from 'react';
import MarketingLayout from './MarketingLayout';
import { COLOR } from '../../components/ss/tokens';

const UPDATED = 'June 2026';
const s = {
  wrapper: { maxWidth: 760, margin: '0 auto', padding: '80px 24px 100px', fontFamily: 'Inter, system-ui, sans-serif' },
  h1: { fontSize: 36, fontWeight: 800, color: COLOR.text, marginBottom: 8 },
  meta: { color: COLOR.textMuted, fontSize: 14, marginBottom: 48 },
  h2: { fontSize: 20, fontWeight: 700, color: COLOR.text, marginTop: 40, marginBottom: 10 },
  p: { color: COLOR.textMuted, lineHeight: 1.75, marginBottom: 16, fontSize: 15 },
  ul: { color: COLOR.textMuted, lineHeight: 1.9, paddingLeft: 20, marginBottom: 16, fontSize: 15 },
};

export default function Terms() {
  return (
    <MarketingLayout title="Terms of Service — Benevita Home Health Care">
      <div style={s.wrapper}>
        <h1 style={s.h1}>Terms of Service</h1>
        <p style={s.meta}>Last updated: {UPDATED} &nbsp;·&nbsp; Benevita Home Health Care</p>

        <p style={s.p}>
          By accessing this website or using Benevita Home Health Care services, you agree to
          these Terms of Service. Please read them carefully.
        </p>

        <h2 style={s.h2}>1. Services</h2>
        <p style={s.p}>
          Benevita provides on-demand, doctor-coordinated home nursing care. Our services include
          wound care, injections, elderly care, physiotherapy, post-surgery care, medication
          management, vital monitoring, and palliative care, delivered by licensed nursing
          professionals.
        </p>

        <h2 style={s.h2}>2. Eligibility</h2>
        <p style={s.p}>
          Services are available within our covered service areas in Kenya. Patients must be
          registered with a valid Kenyan ID or passport. Minors must be registered by a parent
          or legal guardian.
        </p>

        <h2 style={s.h2}>3. Appointments and Cancellations</h2>
        <ul style={s.ul}>
          <li>Appointments must be cancelled at least 2 hours before the scheduled visit.</li>
          <li>Late cancellations (under 2 hours) may incur a cancellation fee of KES 500.</li>
          <li>Repeated no-shows may result in account suspension.</li>
        </ul>

        <h2 style={s.h2}>4. Payment</h2>
        <p style={s.p}>
          Payment is due upon completion of each visit. We accept NHIF, private insurance, M-Pesa,
          bank transfer, and card. Disputed charges must be raised within 7 days of the visit date.
        </p>

        <h2 style={s.h2}>5. Our Obligations</h2>
        <ul style={s.ul}>
          <li>All nurses are licensed by the Nursing Council of Kenya.</li>
          <li>Care is coordinated with your referring doctor where applicable.</li>
          <li>We maintain liability insurance for all clinical staff.</li>
          <li>You will receive a copy of each visit report.</li>
        </ul>

        <h2 style={s.h2}>6. Limitation of Liability</h2>
        <p style={s.p}>
          Benevita is not liable for adverse outcomes resulting from inaccurate medical information
          provided by the patient or family, or from non-compliance with the agreed care plan.
          Emergency clinical decisions made in good faith by our nurses are not grounds for claims
          unless gross negligence is proven.
        </p>

        <h2 style={s.h2}>7. Intellectual Property</h2>
        <p style={s.p}>
          All content on this website — text, logos, images, and software — is the property of
          Benevita Home Health Care and may not be reproduced without written permission.
        </p>

        <h2 style={s.h2}>8. Governing Law</h2>
        <p style={s.p}>
          These terms are governed by the laws of Kenya. Any disputes shall be resolved in the
          courts of Nairobi County.
        </p>

        <h2 style={s.h2}>9. Contact</h2>
        <p style={s.p}>
          For queries about these terms: <strong>legal@benevita.co.ke</strong>
        </p>
      </div>
    </MarketingLayout>
  );
}
